export const sec2uEndpoint = {
  activationSec2u: 'sec2u/v1/sec2u/get',
  pushContentSecure2u: 'sec2u/v1/sec2u/message/push',
  poolingSecure2u: 'sec2u/v1/sec2u/message/confirm',
  checkUserSecure2u: 'sec2u/v1/sec2u/state/check',
  activationSec2uPrelogin: 'sec2u/v1/sec2u/pre/sec2u/check',
  pushContentSecure2uPrelogin: 'sec2u/v1/sec2u/pre/message/push',
  poolingSecure2uPrelogin: 'sec2u/v1/sec2u/pre/message/confirm',
  checkCoolingOff: 'sec2u/v1/sec2u/eligible/check',
  checkCoolingOffPreLogin: 'sec2u/v1/sec2u/pre/eligible/check',
};
